export default "__VITE_ASSET__76d7862b__"